import VuetifyConfirm from "vuetify-confirm";

import rhrCoreShell from "rhr-core-shell";
import SidebarItems from "./shell-options/sidebarItems";
import Routes from "./shell-options/routes";
import AuthOptions from "./shell-options/authOptions";
import UserData from "./shell-options/userData";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import { hasUserPermission } from "./utils/permission";
import permissionStore from "./store/index";
import beforeRouteCallback from "./utils/beforeRouteCallback";
import ErrorLayout from "@/components/common/layout_utils/ErrorLayout";
import AppBarAfterSpacer from "@/components/common/layout_utils/AppBarAfterSpacer";
import { mdiAlert } from "@mdi/js";
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

const options = {
  logo: require("./assets/rcrms.svg"),
  layouts: { ErrorLayout },
  appBarAfterSpacer: AppBarAfterSpacer,
  slogan: "Complete CRM Technology",
  name: "RealCRMSoft",
  authOptions: AuthOptions,
  sidebarItems: SidebarItems,
  routes: Routes,
  userData: UserData,
  storeModules: {
    permission: permissionStore
  },
  permissionGetterName: "permission/hasPermission"
};
const { Vue, vuetify, store, router, $axios, resolveError } = rhrCoreShell(
  options
);

// Sentry.init({
//   Vue,
//   dsn: "https://13124f2f1f294cb28dfb51ed52ef6e18@o72640.ingest.sentry.io/1870013",
//   integrations: [new Integrations.BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

// Sanitize html input
import sanitizeHTML from "sanitize-html";
let defaults = sanitizeHTML.defaults;
defaults.allowedTags = defaults.allowedTags.concat(["img", "u", "sup", "sub"]);
sanitizeHTML.defaults = defaults;
Vue.prototype.$sanitize = sanitizeHTML;

Vue.use(VuetifyConfirm, {
  buttonTrueText: "Accept",
  buttonFalseText: "Discard",
  color: "warning",
  icon: mdiAlert,
  title: "Warning",
  width: 350,
  property: "$confirm"
});
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: "mdiSvg" });

router.beforeEach(beforeRouteCallback(store, resolveError));

$axios.onError(e => {
  if (e.response && ![412, 428, 400].includes(e.response.status)) {
    if (e.response.status === 401) {
      window.$auth.logout();
    } else {
      return resolveError({
        statusCode: e.response.status,
        message: "Nuxt server error"
      });
    }
  }
});

Vue.prototype.$hasPermission = hasUserPermission(store);
